import * as React from 'react';
import { Flex } from 'rebass';
export const ToggleGroup = (props) => {
    return React.createElement(Flex, { className: "ab-Toggle-Group" }, props.children);
};
